import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment } from 'react';
import { PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, PLAYER_INFO_STAT_VALUE_COLOR } from '../../styles/colors';
import { PanelItemDivider } from '../panelItemDivider';
const ITEM_CONTAINER_CSS = css `
  font-size: 85%;
  padding: 3px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 5px;
`;
const ITEM_VALUE_CSS = css `
  color: ${PLAYER_INFO_STAT_VALUE_COLOR};
  flex-grow: 1;
  text-align: right;
`;
export const StatsFieldsContents = ({ statsFields }) => {
    return (_jsx(_Fragment, { children: statsFields.map(([statName, statValue], i) => {
            return (_jsxs(Fragment, { children: [i > 0 ? _jsx(PanelItemDivider, { color: PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, thicknessPx: 2 }) : null, _jsxs("div", { css: ITEM_CONTAINER_CSS, "aria-hidden": true, "aria-label": `${statName}: ${statValue}`, children: [_jsx("span", { children: statName }), _jsx("span", { css: ITEM_VALUE_CSS, children: statValue })] })] }, i));
        }) }));
};
